import $ from 'jquery';
import Backbone from 'backbone';
import Cookie from 'root/lib/cookie';

var Cache = {
    init: function () {
        // app
        this.app                      = null; // object

        // data
        this.account                  = null; // model
        this.workspace                = null; // collection
        this.workspace_member         = null; // collection
        this.portal_user              = null; // model
        this.branding                 = null; // collection
        this.user                     = null; // collection
        this.user_setting             = null; // collection
        this.user_invitation          = null; // collection
        this.user_identification      = null; // collection
        this.user_segment             = null; // collection
        this.project                  = null; // collection
        this.project_domain           = null; // collection
        this.project_access           = null; // collection
        this.project_recording_rule   = null; // collection
        this.workflow                 = null; // collection
        this.invoice                  = null; // collection
        this.api_token                = null; // collection
        this.extension_key            = null; // collection
        this.referral_invoice         = null; // collection
        this.notification             = null; // collection
        this.portal                   = null; // collection
        this.portal_status            = null; // collection
        this.portal_announcement      = null; // collection
        this.survey                   = null; // collection
        this.survey_questions         = null; // collection
        this.survey_response          = null; // collection
        this.widget                   = null; // collection
        this.widget_setting           = null; // collection
        this.widget_trigger_code      = null; // collection
        this.menu                     = null; // collection
        this.inbox_notification       = null; // collection
        this.feedback                 = null; // collection
        this.feedback_category        = null; // collection
        this.feedback_autoreply       = null; // collection
        this.feedback_screenshot      = null; // collection
        this.feedback_comment         = null; // collection
        this.feedback_annotation      = null; // collection
        this.feedback_approver        = null; // collection
        this.feedback_console_log     = null; // collection
        this.feedback_confirmation    = null; // collection
        this.feedback_watch_list      = null; // collection
        this.feedback_network_log     = null; // collection
        this.session_recording        = null; // collection
        this.session_recording_rule   = null; // collection
        this.statistics               = null; // model (virtual)
        this.integration_slack        = null; // collection
        this.integration_jira         = null; // collection
        this.integration_teamwork     = null; // collection
        this.integration_trello       = null; // collection
        this.integration_basecamp     = null; // collection
        this.integration_github       = null; // collection
        this.integration_gitlab       = null; // collection
        this.integration_linear       = null; // collection
        this.integration_intercom     = null; // collection
        this.integration_asana        = null; // collection
        this.integration_clickup      = null; // collection
        this.integration_wrike        = null; // collection
        this.integration_azure_devops = null; // collection
        this.integration_monday       = null; // collection
        this.integration_notion       = null; // collection
        this.integration_zendesk      = null; // collection
        this.integration_webhook      = null; // collection
        this.connected_app_oauth      = null; // collection
        this.connected_app_jira       = null; // collection
        this.connected_app_trello     = null; // collection
        this.connected_app_teamwork   = null; // collection
        this.connected_app_monday     = null; // collection
        this.integration_log          = null; // collection

        this.feedback_comment_template = null; // collection

        this.real_user_id         = 0;
        this.default_workspace_id = 0;
        this.default_project_id   = 0;

        // cookie data
        this.cookie_data         = {}; // object

        // current page
        this.current_page        = null; // string
    },

    // the logged in user
    getRealUser: function() {
        return this.user.get(this.real_user_id);
    },

    // the logged in workspace member
    getRealWorkspaceMember: function() {
        return this.workspace_member.findWhere({user_id: this.real_user_id});
    },

    getDefaultWorkspace: function() {
        return this.workspace.get(this.default_workspace_id);
    },

    getDefaultProject: function() {
        return this.project.get(this.default_project_id);
    },

    getCookieKey: function(key) {
        if (this.default_workspace_id && this.real_user_id) {
            return this.default_workspace_id + '_' + this.real_user_id + '_' + key;
        } else {
            return 'anno_' + key;
        }
    },

    add: function(key, data, set_in_cookie) {
        if (set_in_cookie === undefined) {
            set_in_cookie = true;
        }

        this.cookie_data[key] = data;

        if (set_in_cookie) {
            var one_year = 365 * 24 * 60 * 60;
            Cookie.setItem(this.getCookieKey(key), data, one_year, '/', undefined, true);
        }
    },

    get: function(key) {
        if (this.cookie_data[key]) {
            return this.cookie_data[key];
        } else if (Cookie.hasItem(this.getCookieKey(key))) {
            return Cookie.getItem(this.getCookieKey(key));
        }

        return undefined;
    },

    remove: function(key) {
        delete this.cookie_data[key];
        Cookie.removeItem(this.getCookieKey(key), '/');
    },

    getGuestUser: function() {
        var ext_profile = $('meta[name="userback_ext_profile"]');

        if (ext_profile.length) {
            return {
                email : ext_profile.data('email'),
                name  : ext_profile.data('name')
            };
        } else {
            if (this.guest_user) {
                return {
                    email : this.guest_user.get('email'),
                    name  : this.guest_user.get('name'),
                    type  : this.guest_user.get('type')
                };
            }
        }

        return {
            email : '',
            name  : ''
        };
    },

    setGuestUser: function(email, name, avatar, type) {
        if (this.guest_user) {
            this.guest_user.set({
                email: email,
                name: name,
                avatar: avatar,
                type: type
            });
        } else {
            this.guest_user = new Backbone.Model({
                email: email,
                name: name,
                avatar: avatar,
                type: type
            });
        }
    },

    removeGuestUser: function() {
        this.guest_user.clear();
    }
};

Cache.init();

export default Cache;
